import { TypeChecker } from '@attain-apps/type-guards'

/**
 * The uploaded documents a workflow reads, as raw bytes keyed by the role each
 * one plays (e.g. `cashDraw`, `glReport`).
 */
export type SourceFiles<TKey extends string> = Readonly<
  Record<TKey, Uint8Array>
>
export namespace SourceFiles {
  const isBytes = TypeChecker.Factory.instance(Uint8Array)

  /**
   * A type checker for a bundle with exactly the given keys.
   */
  export function checker<TKey extends string>(
    keys: readonly TKey[],
  ): TypeChecker<SourceFiles<TKey>> {
    return TypeChecker.Factory.object<SourceFiles<TKey>>(
      Object.fromEntries(
        keys.map(key => [key, isBytes]),
      ) as TypeChecker.Factory.object.Fields<SourceFiles<TKey>>,
    )
  }
}
